export const styles = theme => ({
  container: {
    maxWidth: 960,
    margin: 'auto'
  }
})



// WEBPACK FOOTER //
// ./src/components/Users/styles.js